const LicencePage = ({}) => {
  return (
    <h2>Страница Лицензии</h2>
  );
};

export default LicencePage;